import _objectSpread from "/var/jenkins_home/workspace/mka-pc_prod/node_modules/@babel/runtime/helpers/objectSpread2.js";
import _toConsumableArray from "/var/jenkins_home/workspace/mka-pc_prod/node_modules/@babel/runtime/helpers/toConsumableArray.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import jDictSelect from './j-dict-select.vue';
import JUpload from './j-upload.vue';
export default {
  components: {
    jDictSelect: jDictSelect,
    JUpload: JUpload
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    config: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    className: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'form'
    }
  },
  data: function data() {
    var _this = this;
    var validateLonLat = function validateLonLat(rule, value, callback) {
      var _this$config$find = _this.config.find(function (item) {
          return item.prop == rule.field;
        }),
        label = _this$config$find.label;
      var _this$config$find2 = _this.config.find(function (item) {
          return item.prop == rule.field;
        }),
        requiredLabel = _this$config$find2.requiredLabel;
      var keys = rule.field.split('.');
      if (!_this.form[keys[keys.length - 1]]) {
        return callback(new Error(requiredLabel || "".concat(label, "\u4E0D\u80FD\u4E3A\u7A7A")));
      } else {
        callback();
      }
    };
    return {
      addLonLatRules: [{
        trigger: 'blur',
        validator: validateLonLat,
        required: true
      }],
      rules: {},
      form: {},
      validations: {
        phone: {
          trigger: 'blur',
          validator: function validator(rule, value, callback) {
            var phone = /^(?:(?:\+|00)86)?1\d{10}$/;
            var landline = /^(?:(?:\d{3}-)?\d{8}|^(?:\d{4}-)?\d{7,8})(?:-\d+)?$/;
            if (!value) return callback();
            if (phone.test(value)) {
              callback();
            } else if (landline.test(value)) {
              callback();
            } else {
              callback('格式错误');
            }
          }
        },
        email: {
          message: '邮箱格式错误',
          trigger: 'blur',
          validator: function validator(rule, value, callback) {
            if (!value) return callback();
            if (value.indexOf('@') != -1) {
              callback();
            } else {
              callback('邮箱格式错误');
            }
          }
        },
        idCard: {
          message: '身份证格式错误',
          trigger: 'blur',
          pattern: /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/
        },
        password: {
          message: '必须包含数字+字母，长度8-15个字符',
          trigger: 'blur',
          pattern: /^.{8,15}$/
        },
        bankCard: {
          message: '银行卡格式错误',
          trigger: 'blur'
        },
        landline: {
          message: '座机号格式错误',
          trigger: 'blur',
          pattern: /^(?:(?:\d{3}-)?\d{8}|^(?:\d{4}-)?\d{7,8})(?:-\d+)?$/
        },
        creditCode: {
          message: '信用代码格式错误',
          trigger: 'blur',
          pattern: /^(([0-9A-Za-z]{15})|([0-9A-Za-z]{18})|([0-9A-Za-z]{20}))$/
        }
      }
    };
  },
  watch: {
    value: {
      handler: function handler(val) {
        if (val) {
          this.form = val;
        } else {
          this.form = {};
        }
      },
      deep: true,
      immediate: true
    },
    form: {
      handler: function handler(val) {
        this.$emit('input', val);
        this.$emit('change', val);
      },
      deep: true
    },
    config: {
      handler: function handler(val) {
        var _this2 = this;
        var rules = {};
        var types = {
          input: true,
          phone: true,
          number: true,
          'input-number': true
        };
        val.forEach(function (item) {
          if (item.required) {
            var required = {
              required: true,
              message: types[item.type] ? '请输入' + item.label : '请选择' + item.label,
              trigger: item.trigger || ['change', 'blur']
            };
            if (item.rules) {
              rules[item.name] = [].concat(_toConsumableArray(_this2.setRule(item.rules)), [required]);
            } else {
              rules[item.name] = [required];
            }
          } else {
            rules[item.name] = item.rules ? _this2.setRule(item.rules) : [];
          }
        });
        this.rules = rules;
        this.$nextTick(function () {
          if (_this2.$refs['form'] && _this2.$refs['form'].clearValidate) {
            _this2.$refs['form'].clearValidate();
          }
        });
      },
      deep: true,
      immediate: true
    }
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    getEval: function getEval(name) {
      var form = _objectSpread({}, this.form);
      return this.getDescendantProp(form, name);
    },
    setEval: function setEval(value, name) {
      var form = _objectSpread({}, this.form);
      this.setDescendantProp(form, name, value);
      this.form = form;
    },
    getDescendantProp: function getDescendantProp(obj, desc) {
      var arr = desc.split('.');
      try {
        while (arr.length) {
          obj = obj[arr.shift()];
        }
      } catch (_unused) {
        obj = undefined;
      }
      return obj;
    },
    setDescendantProp: function setDescendantProp(obj, desc, value) {
      var arr = desc.split('.');
      while (arr.length > 1) {
        obj = obj[arr.shift()];
      }
      return obj[arr[0]] = value;
    },
    setRule: function setRule(rows) {
      var _this3 = this;
      if (!rows) return;
      var arr = [];
      var validationsKey = Object.keys(this.validations);
      rows.forEach(function (item) {
        if (item.type && validationsKey.includes(item.type)) {
          arr.push(_this3.validations[item.type]);
        } else {
          arr.push(item);
        }
      });
      return arr;
    },
    submit: function submit() {
      var _this4 = this;
      return new Promise(function (resolve, reject) {
        _this4.$refs.form.validate(function (valid) {
          if (valid) {
            resolve(_this4.form);
          } else {
            _this4.$nextTick(function () {
              var isError = document.getElementsByClassName('is-error');
              var errorText = isError[0].querySelector('.el-form-item__error').innerText;
              _this4.$message.warning(errorText);
              isError[0].scrollIntoView({
                block: 'center',
                behavior: 'smooth'
              });
            });
          }
        });
      });
    },
    resetFields: function resetFields() {
      this.$refs.form.resetFields();
    }
  }
};